export enum PackageType {
    Cms = 2,
    Server = 3,
    SoftwarePackage = 4
}